import { render } from "./MBooksList.vue?vue&type=template&id=10c33b94&scoped=true"
import script from "./MBooksList.vue?vue&type=script&lang=js"
export * from "./MBooksList.vue?vue&type=script&lang=js"

import "./MBooksList.vue?vue&type=style&index=0&id=10c33b94&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c33b94"]])

export default __exports__